export function resize(
  limits: { width: number; height: number },
  ratio: number // height / width
): { width: number; height: number } {
  const fitToWidth = { width: limits.width, height: limits.width * ratio };
  const fitToHeight = { width: limits.height / ratio, height: limits.height };

  const fitsInLimits = (size: { width: number; height: number }) =>
    size.width <= limits.width && size.height <= limits.height;

  return fitsInLimits(fitToWidth) ? fitToWidth : fitToHeight;
}
